import api from '../services/api';

// Principio #2 del producto: nunca tocar algo con una llamada en curso.
// (/impeccable critique, 30-sep-2026 — P0: las acciones destructivas no lo
// verificaban pese a que el dato ya existe en el backend.)

// Estados de PJSIP devicestate que significan que hay audio o timbrado en
// curso en esa extensión (ExtensionsPage ya trae ext.liveStatus en cada fila,
// viene de GET /extensions -> ExtensionService.getLiveStatus()).
const IN_CALL_STATES = new Set(['INUSE', 'BUSY', 'RINGING', 'RINGINUSE', 'ONHOLD']);

export function extensionHasActiveCall(liveStatus) {
  return IN_CALL_STATES.has(String(liveStatus || '').toUpperCase());
}

// Empresas no tienen un devicestate propio; se reutiliza el conteo que ya
// calcula /dashboard/companies-status (mismo endpoint del Dashboard del
// System Owner) en vez de duplicar la lógica de AMI en el frontend.
export async function companyHasActiveCall(companyId) {
  try {
    const res = await api.get('/dashboard/companies-status');
    const row = res.data.find((c) => c.id === companyId);
    return (row?.activeCalls || 0) > 0;
  } catch {
    // Fail-open, mismo criterio que pbx_call_limit.agi: si el chequeo en sí
    // falla (AMI caído), no se bloquea el trabajo administrativo normal por
    // eso — se avisa y se deja decidir a quien confirma.
    return null;
  }
}
